import { createFileRoute } from "@tanstack/react-router"

import { SignatureBuilder } from "@/pages/SignatureBuilder"

export const Route = createFileRoute("/it/signature")({
  component: SignatureBuilder,
})
